// +----------------------------------------------------------------------
// | Desc: api接口管理库
// +----------------------------------------------------------------------
import https from "@/layout/config/https.js";

const $api = {
  // +----------------------------------------------------------------------
  // | Desc: 全局数据
  // +----------------------------------------------------------------------
  //用户登录
  login: function (data) {
    return https.post("/zxbigscreen/login/login", data);
  },

  //街道列表
  getStreetList: function (data) {
    return https.post("/zxbigscreen/City/getStreetList", data);
  },

  // +----------------------------------------------------------------------
  // | Desc: 大屏数据统计
  // +----------------------------------------------------------------------
  //大屏数据统计
  getTotal: function (data) {
    return https.post("/zxbigscreen/Tongji/getTotal", data);
  },

  //获取排收分布坐标
  getPaiShouZuobiao: function (data) {
    return https.post("/zxbigscreen/Tongji/getPaiShouZuobiao", data);
  },

  //清运线路图
  getQingyunXianLu: function (data) {
    return https.post("/zxbigscreen/Tongji/getQingyunXianLu", data);
  },

  //热力图计算
  getQingyunReli: function (data) {
    return https.post("/zxbigscreen/Tongji/getQingyunReli", data);
  },

  //按年份获取数据
  getTotalByYear: function (data) {
    return https.post("/zxbigscreen/Tongji/getTotalByYear", data);
  },

  //局部更新(排放排名)
  getPFPM: function (data) {
    return https.post("/zxbigscreen/Tongji/getPFPM", data);
  },

  //局部更新(处置排名)
  getCZPM: function (data) {
    return https.post("/zxbigscreen/Tongji/getCZPM", data);
  },

  //大屏数据统计(热更新)
  getTotalHot: function (data) {
    return https.post("/zxbigscreen/Tongji/getTotalHot", data);
  },

  // +----------------------------------------------------------------------
  // | Desc: 排放单位
  // +----------------------------------------------------------------------
  //数据列表
  getOrgpaifangList: function (data) {
    return https.post("/zxbigscreen/Orgpaifang/getList", data);
  },

  //数据详情
  getOrgpaifangDetailed: function (data) {
    return https.post("/zxbigscreen/Orgpaifang/getDetailed", data);
  },

  // +----------------------------------------------------------------------
  // | Desc: 排放分类
  // +----------------------------------------------------------------------
  //数据列表
  getPFLX: function (data) {
    return https.post("/zxbigscreen/Tongji/getPFLX", data);
  },
 // +----------------------------------------------------------------------
  // | Desc: 单位
  // +----------------------------------------------------------------------
  //数据列表
  getOrggsList: function (data) {
    return https.post("/zxbigscreen/Orggs/getList", data);
  },

  //数据详情
  getOrggsDetailed: function (data) {
    return https.post("/zxbigscreen/Orggs/getDetailed", data);
  },
  
  // +----------------------------------------------------------------------
  // | Desc: 运输单位
  // +----------------------------------------------------------------------
  //数据列表
  getOrgyunshuList: function (data) {
    return https.post("/zxbigscreen/Orgyunshu/getList", data);
  },

  //数据详情
  getOrgyunshuDetailed: function (data) {
    return https.post("/zxbigscreen/Orgyunshu/getDetailed", data);
  },

  // +----------------------------------------------------------------------
  // | Desc: 接收单位
  // +----------------------------------------------------------------------
  //数据列表
  getOrgjieshouList: function (data) {
    return https.post("/zxbigscreen/Orgjieshou/getList", data);
  },

  //数据详情
  getOrgjieshouDetailed: function (data) {
    return https.post("/zxbigscreen/Orgjieshou/getDetailed", data);
  },

  // +----------------------------------------------------------------------
  // | Desc: 项目备案
  // +----------------------------------------------------------------------
  //读取列表
  getFilingList: function (data) {
    return https.post("/zxbigscreen/Filing/getList", data);
  },

  //读取详情
  getFilingDetailed: function (data) {
    return https.post("/zxbigscreen/Filing/getDetailed", data);
  },

  // +----------------------------------------------------------------------
  // | Desc: 车辆管理
  // +----------------------------------------------------------------------
  //读取列表
  getCarList: function (data) {
    return https.post("/zxbigscreen/Car/getList", data);
  },
  //读取详情
  getCarDetailed: function (data) {
    return https.post("/zxbigscreen/Car/getDetailed", data);
  },

  //读取列表
  getBoxList: function (data) {
    return https.post("/zxbigscreen/Box/getList", data);
  },

  //读取详情
  getBoxDetailed: function (data) {
    return https.post("/zxbigscreen/Box/getDetailed", data);
  },
  
  // +----------------------------------------------------------------------
  // | Desc: 船舶管理
  // +----------------------------------------------------------------------
  //读取列表
  getShipList: function (data) {
    return https.post("/zxbigscreen/Ship/getList", data);
  },
  
   // +----------------------------------------------------------------------
  // | Desc:注册用户
  // +----------------------------------------------------------------------
  //读取列表
  getUserList: function (data) {
    return https.post("/zxbigscreen/User/getUserList", data);
  },

  // +----------------------------------------------------------------------
  // | Desc:资源处置场单位列表
  // +----------------------------------------------------------------------
  //读取列表
  getOrgZYCZList: function (data) {
    return https.post("/zxbigscreen/Orgjieshou/getzyczList", data);
  },

   // +----------------------------------------------------------------------
  // | Desc:堆放单位列表
  // +----------------------------------------------------------------------
  //读取列表
  getOrgduifangList: function (data) {
    return https.post("/zxbigscreen/Orgduifang/getList", data);
  },

   // +----------------------------------------------------------------------
  // | Desc:堆放单位详情
  // +----------------------------------------------------------------------
  //读取列表
  getOrgduifangDetailed: function (data) {
    return https.post("/zxbigscreen/Orgduifang/getDetailed", data);
  },

  //读取详情
  getShipDetailed: function (data) {
    return https.post("/zxbigscreen/Ship/getDetailed", data);
  },

  // +----------------------------------------------------------------------
  // | Desc: 装修订单
  // +---------------------------------------------------------------------
  //读取列表
  getProjectList100: function (data) {
    return https.post("/zxbigscreen/Project/getList100", data);
  },

  // +----------------------------------------------------------------------
  // | Desc: 工地订单
  // +---------------------------------------------------------------------
  //读取列表
  getProjectList200: function (data) {
    return https.post("/zxbigscreen/Project/getList200", data);
  },


  //读取详情
  getProjectDetailed: function (data) {
    return https.post("/zxbigscreen/Project/getDetailed", data);
  },

  // +----------------------------------------------------------------------
  // | Desc: 电子联单
  // +----------------------------------------------------------------------
  //读取电子联单列表
  getElectronicbillList: function (data) {
    return https.post("/zxbigscreen/Electronicbill/getList", data);
  },

  //读取电子联单详情
  getElectronicbillDetailed: function (data) {
    return https.post("/zxbigscreen/Electronicbill/getDetailed", data);
  },
  //查看运营团队数据的时候下拉选择(这个时候无论运营团队的状态如何都需要查询到，因为涉及到先运营一段时间后再停止运营)
  getCityteamSelectListByAll: function (data) {
    return https.post('/zxbigscreen/City/getCityteamSelectListByAll', data)
},
  //工地单、整车运、零散运、堆放运下单或者修改时运输作业单位选择列表
  getOrgSelectListByYunshu: function (data) {
    return https.post('/zxbigscreen/Orgyunshu/getOrgSelectListByYunshu', data)
},

};
export default $api;
